/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// A long prompt is edited part by part: each "# HEADING" is a box with a plain title, and
// the headings themselves aren't editable, so nobody can break the prompt's structure.

// heading (as in ANNA's default prompts) => what the box is called, and what it changes
const PARTS = {
  'IDENTITY & ROLE': [
    'Who Anna is',
    'Her name, her job on the call, and her tone.',
  ],
  PRONUNCIATION: [
    'How she says the company name',
    'How "Webxloo" is spoken. Change only if she says it wrong.',
  ],
  'YOUR CALL FACTS': [
    'What she knows about each call',
    'Where the candidate, the role and her questions come from. Rarely needs changing.',
  ],
  'GUARDRAILS - ABSOLUTE': [
    'What she must never say or do',
    'Pay and contracts, the company facts she may share, the one email address she gives, staying polite.',
  ],
  'HOW YOU LISTEN AND TALK': [
    'How she listens and talks',
    'Short turns, waiting while people think, follow-up questions, not repeating herself.',
  ],
  'THE INTERVIEW, PHASE BY PHASE': [
    'How she runs each part of the interview',
    'What she does in each part. The questions themselves are the question blocks above.',
  ],
  'ENDING THE CALL': [
    'How she ends the call',
    'Closing, and what to do when the candidate leaves or goes quiet.',
  ],
};

const norm = (heading) =>
  heading.toUpperCase().replace(/[—–]/g, '-').replace(/\s+/g, ' ').trim();

/** The prompt as parts: [{heading, title, hint, body}]; no "# " heading = one part. */
export const splitPrompt = (text) => {
  const parts = [];
  let current = {heading: null, lines: []};
  String(text || '')
    .split('\n')
    .forEach((line) => {
      const m = line.match(/^# (.+)$/);
      if (m) {
        parts.push(current);
        current = {heading: m[1].trim(), lines: []};
      } else {
        current.lines.push(line);
      }
    });
  parts.push(current);
  return parts
    .map((p) => {
      const [title, hint] = PARTS[norm(p.heading || '')] || [p.heading, ''];
      return {
        heading: p.heading,
        title,
        hint,
        // the "---" between parts is put back by joinPrompt
        body: p.lines
          .join('\n')
          .replace(/\n\s*-{3,}\s*$/, '')
          .trim(),
      };
    })
    .filter((p) => p.heading !== null || p.body !== '');
};

/** The parts back as one prompt, as ANNA stores it. */
export const joinPrompt = (parts) =>
  parts
    .map((p) =>
      p.heading === null ? p.body.trim() : `# ${p.heading}\n\n${p.body.trim()}`,
    )
    .join('\n\n---\n\n');
